import { render, staticRenderFns } from "./UpsellAlerts.vue?vue&type=template&id=4ff09d44&"
import script from "./UpsellAlerts.vue?vue&type=script&lang=js&"
export * from "./UpsellAlerts.vue?vue&type=script&lang=js&"
import style0 from "./UpsellAlerts.vue?vue&type=style&index=0&id=4ff09d44&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports